import React from 'react';
import classNames from 'classnames';
import { SectionSplitProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';
import Image from '../elements/Image';

const propTypes = {
  ...SectionSplitProps.types
}

const defaultProps = {
  ...SectionSplitProps.defaults
}

const BlogView = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  invertMobile,
  invertDesktop,
  alignTop,
  imageFill,
  ...props
}) => {


  const outerClasses = classNames(
    'features-split section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'features-split-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const splitClasses = classNames(
    'split-wrap',
    invertMobile && 'invert-mobile',
    invertDesktop && 'invert-desktop',
    alignTop && 'align-top'
  );

  const sectionHeader = {
    title: 'SPPhotonic Fluid Analysis Blog',
    paragraph: "Find the latest Discussions and Applications of SPPhotonic Fluid Analysis Devices"
  };

  return (
    <section
      {...props}
      className={outerClasses}
    >
      <div className="container">
        <div className={innerClasses}>
          <SectionHeader data={sectionHeader} className="center-content" />
          <div className={splitClasses}>

            <div className="split-item">

              <div className="split-item-content center-content-mobile reveal-from-left" data-reveal-container=".split-item">
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                  January 10, 2024
                  </div>
                <h3 className="mt-0 mb-12">
                  Digital Chemical Reactor with Real Time Analytics
                  </h3>
                <p className="m-0">
                <a href="https://www.spphotonic.com/blog/digital-chemistry.html">
                  <code>Digital Chemical Reactor </code>
                </a>
                  </p>
              </div>

              <div className={
                classNames(
                  'split-item-image center-content-mobile reveal-from-bottom',
                  imageFill && 'split-item-image-fill'
                )}
                data-reveal-container=".split-item">
                <Image
                  src={require('./../../assets/images/ContinuousFlowV2.jpg')}
                  alt="Data Visualized Raman 01"
                  width={528}
                  height={396}
                  className={'rounded-lg', 'img-thumbnail'}
                   />
              </div>

            </div>

            <div className="split-item">
            
              <div className="split-item-content center-content-mobile reveal-from-left" data-reveal-container=".split-item">
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                  Tuesday May 3, 2021
                  </div>
                <h3 className="mt-0 mb-12">
                  Continuous Flow Sensing with Real Time Analytics
                  </h3>
                <p className="m-0">
                <a href="https://www.spphotonic.com/blog/inline-flow.html">
                  <code>Continuous Flow Sensing with Real Time Analytics. </code>
                </a>
                  </p>
              </div>

              <div className={
                classNames(
                  'split-item-image center-content-mobile reveal-from-bottom',
                  imageFill && 'split-item-image-fill'
                )}
                data-reveal-container=".split-item">
                <Image
                  src={require('./../../assets/images/ContinuousFlowV2.jpg')}
                  alt="Data Visualized Raman 01"
                  width={528}
                  height={396}
                  className={'rounded-lg', 'img-thumbnail'}
                   />
              </div>

            </div>
   <div className="split-item">

              <div className="split-item-content center-content-mobile reveal-from-left" data-reveal-container=".split-item">
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                  Friday January 10, 2021
                  </div>
                <h3 className="mt-0 mb-12">
                  Analytical Chemical Blog with Real Time Analytics
                  </h3>
                <p className="m-0">
                <a href="https://www.spphotonic.com/blog/analytical-chemistry.html">
                  <code>Analytical Instruments for Advanced Energy Applications</code>
                </a>
                  </p>
              </div>

              <div className={
                classNames(
                  'split-item-image center-content-mobile reveal-from-bottom',
                  imageFill && 'split-item-image-fill'
                )}
                data-reveal-container=".split-item">
                <Image
                  src={require('./../../assets/images/Photochemistry.jpg')}
                  alt="Photochemistry"
                  width={528}
                  height={396}
                  className={'rounded-lg', 'img-thumbnail'}
                   />
              </div>

            </div>




          </div>
        </div>
      </div>
    </section>
  );
}

BlogView.propTypes = propTypes;
BlogView.defaultProps = defaultProps;

export default BlogView;